/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-loop-func */
import { DefaultPortModel } from "@projectstorm/react-diagrams";
import { forEach } from "lodash";
import BandwidthLinkModel from "./BandwidthLink/BandwidthLinkModel";

function BoldLinkPath(link: any, width: number) {
  /*
John Egnatis:
  BoldLinkPath starts given one link and a width value, to set the new links to.
We iterate through a list, initially of size one. Each iteration, we bold the links
in the paths array, and push all arrays onto an exploredIDs array. If the we find
a path that does not belong in the exploredIDs array, we will push that link to
be explored, and add 1 to pathSize. End condition is if in any iteration of
pathsCopy.forEach, paths does not get any new paths to search, or we explore the max
number of paths allowed.
*/
  let pathSize = 0;
  const MAX_PATH_SIZE = 20;
  let paths: any = [link];
  const linkIDs: any[] = [];
  const extras = link.getOptions().extras;
  if (extras && extras.sourceCollapsed && extras.targetCollapsed && extras.multipleCrossConnectsBetweenGroups) {
    return;
  }
  try {
    while (paths && paths.length > 0 && pathSize < MAX_PATH_SIZE) {
      const pathsCopy = [...paths];
      paths = [];
      pathsCopy.forEach((path: any) => {
        linkIDs.push(path.getOptions().id);
        if (path && path.sourcePort) {
          forEach(path.sourcePort.getLinks(), (link) => {
            link.setWidth(width);
            if (!linkIDs.includes(link.getOptions().id)) {
              if (link.renderedPaths && link.renderedPaths.length > 0) {
                paths.push(link);
                pathSize++;
              }
            }
          });
        }
        if (path && path.targetPort) {
          forEach(path.targetPort.getLinks(), (link) => {
            link.setWidth(width);
            if (!linkIDs.includes(link.getOptions().id)) {
              if (link.renderedPaths && link.renderedPaths.length > 0) {
                paths.push(link);
                pathSize++;
              }
            }
          });
        }
      });
    }
  } catch (e: any) {
    return null;
  }
}
export default BoldLinkPath;
